import * as React from 'react'

import {ConnectedProps} from 'react-redux'

import {State} from '../reducers'

import {connect} from '../../../commons/src/services/loop'

import {Permission} from '../types'

const mapStateToProps = (state: State) => ({
  authUser: state.auth.user,
})

const mapDispatchToProps = {}

interface OwnProps {
  children: React.ReactNode
  requiredPermissions: Permission[]
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type Props = ConnectedProps<typeof connector> & OwnProps

const RequireAuthPartial = ({authUser, requiredPermissions, children}: Props) => {
  if (!!authUser && requiredPermissions.includes(authUser.permission)) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>
  }
  return null
}
export default connector(RequireAuthPartial)
